<template>
  <canvas ref="chart"></canvas>
</template>

<script>
import Chart from "chart.js";
import { parseBRPattern } from "@/models/Utils.js";

export default {
  name: "ChartDates",
  props: {
    datasets: Array,
    eu: { type: String, default: "MWh" },
    period: {
      type: String,
      default: "year",
    },
    mobile: { type: Boolean, default: false },
  },
  data: () => ({
    chart: null,
    config: {
      type: "bar",
      data: {
        datasets: [],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        animation: {
          duration: 200,
        },
        hover: {
          animationDuration: 0,
        },
        responsiveAnimationDuration: 0,
        tooltips: {
          callbacks: {
            label: (tooltipItem, data) => {
              const tooltip = data.datasets[tooltipItem.datasetIndex];
              const item = tooltip.data[tooltipItem.index];
              if ((!item || !item.y) && item.y != 0) return;
              let show = parseBRPattern(item.y);
              return tooltip.label + ": " + show;
            },
          },
          mode: "index",
          intersect: false,
        },
        elements: {
          point: {
            radius: 0,
          },
          line: {
            tension: 0.1,
          },
        },
        legend: {
          onClick() {},
          display: false,
        },
        scales: {
          yAxes: [
            {
              id: "left",
              position: "left",
              display: true,
              stacked: true,
              scaleLabel: {
                display: true,
                labelString: "MWh",
                fontColor: "#666666",
                fontSize: 13,
              },
              gridLines: {
                color: "#a5b0c04b",
              },
              ticks: {
                fontColor: "#666666",
                beginAtZero: true,
                maxTicksLimit: 6,
                callback: function (label, index, labels) {
                  return parseBRPattern(String(label));
                },
              },
            },
          ],
          xAxes: [
            {
              id: 0,
              type: "time",
              distribution: "series",
              stacked: true,
              display: true,
              offset: true,
              gridLines: {
                color: "#a5b0c04b",
                drawOnChartArea: false,
              },
              ticks: {
                callback(value, index, values) {
                  return value;
                },
                fontColor: "#666666",
                fontSize: 12,
                autoSkip: true,
                maxTicksLimit: 12,
                maxRotation: 0,
              },
              scaleLabel: {
                display: false,
                labelString: "Days",
              },
              time: {
                unit: "month",
                unitStepSize: 1,
                tooltipFormat: "MMM YYYY",
                displayFormats: {
                  month: "MMM",
                },
              },
            },
          ],
        },
      },
    },
  }),
  watch: {
    period: {
      handler() {
        this.changeXAxis();
      },
    },
    datasets: {
      handler(val) {
        this.addDataset(val);
      },
    },
    eu: {
      handler() {
        this.setEu();
        this.chart.update();
      },
    },
    mobile: {
      handler() {
        this.ticksLimit();
        this.chart.update();
      },
    },
  },
  mounted() {
    this.createChart();
  },
  methods: {
    changeXAxis() {
      const period = this.period.toLowerCase();
      let time = {
        unit: "month",
        unitStepSize: 1,
        tooltipFormat: "MMM YYYY",
        displayFormats: {
          month: "MMM",
        },
      };
      switch (period) {
        case "month":
          time = {
            unit: "day",
            tooltipFormat: "DD MMM",
            displayFormats: {
              day: "DD MMM",
            },
          };
          break;
        case "day":
          time = {
            unit: "hour",
            tooltipFormat: "DD/MM HH:mm",
            displayFormats: {
              day: "HA",
            },
          };
          break;
        default:
          break;
      }

      this.config.options.scales.xAxes[0].time = time;
    },
    setEu() {
      this.config.options.scales.yAxes[0].scaleLabel.labelString = this.eu;
    },
    createChart() {
      this.ticksLimit();
      this.setEu();
      const context = this.$refs.chart;
      this.chart = new Chart(context, this.config);
    },
    addDataset(datasets) {
      this.config.data.datasets = datasets;
      this.chart.update();
    },
    ticksLimit() {
      if (this.mobile) {
        this.config.options.scales.xAxes[0].ticks.maxTicksLimit = 6;
      } else this.config.options.scales.xAxes[0].ticks.maxTicksLimit = 12;
    },
  },
};
</script>

<style></style>
